import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../apiClient'
import { DailyPanchangResponse, Data } from './type'

class GandalfApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  getPanchangData = async (month: string) => {
    return this.api.get<Data>('/gw2/gandalf/internal/v1/panchang/monthly', {
      params: {
        month: month,
        district_slug: 'varanasi-uttar-pradesh-india',
        lat: '25.287',
        lng: '82.6763',
      },
      headers: {
        'x-afb-language-mode': 'en',
        'accept-language': 'en',
      },
    })
  }
  getDeityRashiData = async (key: string) => {
    return this.api.get<Data>('/gw2/gandalf/internal/v1/utils', {
      params: {
        key: key,
      },
      headers: {
        'x-afb-language-mode': 'en',
        'accept-language': 'en',
      },
    })
  }

  getDailyPanchang = async (date: string) => {
    return this.api.get<DailyPanchangResponse>(
      '/gw2/gandalf/internal/v1/panchang/daily',
      {
        params: {
          date: date,
        },
      },
    )
  }
}

export default GandalfApi
